<template>
  <div class="container supplierResourceManageDetail">
    <el-tabs v-model="currentTab" style="min-height:400px">
      <el-tab-pane :label="$t('supplierManage.basicInfo')" name="1">
        <!-- 基础信息 -->
        <div class="searchBox_top">
          <el-button type="primary" v-if="canEdit || canMdmUpdate" @click="saveDetail" v-acl="SaveSupplierResource">{{$t('common.saveDraft')}}</el-button>
          <!--保存-->
          <el-button type="primary" v-if="canEdit || canMdmUpdate" @click="submitDetail" v-acl="SubmitSupplierResource">{{$t('common.submit')}}</el-button>
          <!--提交-->
          <el-button type="primary" v-if="canUpdate && isGroup" @click="SSDataUpdate" v-acl="SubmitSupplierResource">{{$t('supplierManage.dataUpdate')}}</el-button>
          <!--SS数据更新-->
          <!-- <el-button type="primary" v-show="canChangeFormal" @click="changeFormal" v-acl="UpdatePotentialSupplierStatus">{{$t('supplierManage.approvalSuppliers')}}</el-button>批准供应商 转正式 -->
          <el-button type="primary" v-if="canAudit" @click="approvalSuppliers" v-acl="ApproveSupplierResource">{{$t('supplierManage.audit')}}</el-button>
          <!--审批-->
          <el-button type="primary" @click="historyBack">{{ $t('common.close') }}</el-button>
        </div>
        <div class="scrollYBox">
          <el-card class="box-card" v-if="emplFlag != 'SUP' && groupType == 'SUPPLIER'">
            <!--供应商品类信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierCategoryInfo') }}</span>
            </div>
            <el-form :model="CategoryInfoForm" ref="CategoryInfoForm" :rules="CategoryInfoRules" label-width="120px">
              <el-row>
                <el-form-item :label="$t('supplierManage.Category1')" prop="categoryLevel1Id">
                  <el-checkbox-group v-model="CategoryInfoForm.categoryLevel1Id">
                    <el-checkbox v-for="(item, index) in categoryList1" :label="item.tmCategoryId" :key="index" @change="changeCategory1($event, item.tmCategoryId, item.name)">{{ item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item :label="$t('supplierManage.Category2')" prop="categoryLevel2Id">
                  <el-checkbox-group v-model="CategoryInfoForm.categoryLevel2Id">
                    <el-checkbox v-for="(item, index) in categoryList2" :label="item.tmCategoryId" :key="index" @change="changeCategory2($event, item)"><span class="Categorypname">{{ item.pname }}：</span>{{
                        item.name }}</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-row>
            </el-form>
          </el-card>
          <el-card class="box-card" v-if="createType != 'MDM'">
            <!--保密协议  非SS 不显示-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.confidentialityAgreement') }}</span>
            </div>
            <el-table :data="lawFileList" ref="lawFileList" border highlight-current-row max-height='420'>
              <el-table-column show-overflow-tooltip :label="$t('supplierManage.fileName')">{{
                $t('supplierManage.confidentialityAgreement') }}</el-table-column>
              <!--文件名-->
              <el-table-column show-overflow-tooltip :label="$t('common.file')" prop='current'>
                <!--文件-->
                <template>
                  <!--保密协议下载-->
                  <el-link type="primary" @click.native="downloadTemplate('/templates/download/附件二 麦当劳保密协议_CN.PDF', '附件二 麦当劳保密协议_CN.PDF')">附件二
                    麦当劳保密协议_CN.PDF</el-link>
                  <el-link type="primary" @click.native="downloadTemplate('/templates/download/附件二 麦当劳保密协议_ENCN.PDF', '附件二 麦当劳保密协议_ENCN.PDF')">附件二
                    麦当劳保密协议_ENCN.PDF</el-link>
                  <!-- <el-link type="primary" @click.native="downloadTemplate()">{{$t('supplierManage.agreementDownload')}}</el-link> -->
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip :label="$t('common.status')" prop='statusI18n'></el-table-column>
              <el-table-column show-overflow-tooltip :label="$t('base.linePrice.operation')">
                <template slot-scope="scope">
                  <el-link type="primary" v-acl="SubmitSupplierResource" @click.native="apply(scope.row)" style="margin-right:20px" v-if="isGroup">{{
                    $t('supplierManage.apply') }}</el-link>
                  <el-link type="primary" v-show="scope.row.tmLawFileId" v-acl="SubmitSupplierResource" @click.native="seeLegalFileDetail(scope.row)">{{
                    $t('common.see') }}</el-link>
                </template>
              </el-table-column>
              <!-- <el-table-column label="归档"></el-table-column> -->
            </el-table>
          </el-card>
          <el-card class="box-card">
            <!--供应商基础信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierBasicInfo') }}</span>
            </div>
            <el-form :model="basicInfoForm" ref="basicInfoForm" :rules="basicInfoRules" label-width="130px">
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierName">
                    <!--供应商中文名称-->
                    <el-input v-model="basicInfoForm.supplierName" clearable :disabled="!(canEdit || canUpdate)" maxlength="60"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
                    <!--供应商简称-->
                    <el-input v-if="emplFlag == 'SUP'" v-model="basicInfoForm.supplierNameShort" clearable disabled maxlength="60"></el-input>
                    <el-input v-else v-model="basicInfoForm.supplierNameShort" clearabl></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierInvitationCode')" prop="invitationCode">
                    <!--供应商邀请码-->
                    <el-input v-model.trim="basicInfoForm.invitationCode" clearable disabled></el-input>
                  </el-form-item>
                </el-col>

              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierNameEn">
                    <!--供应商英文名称-->
                    <el-input v-model="basicInfoForm.supplierNameEn" clearable :disabled="!(canEdit || canUpdate)" maxlength="100"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierType')" prop="groupType">
                    <!--供应商类型-->
                    <ic-select clearable table="TM_SUPPLIER" field="GROUP_TYPE" v-model="basicInfoForm.groupType" disabled></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.supplierInviter')" prop="inviter">
                    <!--供应商邀请人-->
                    <el-input v-model.trim="basicInfoForm.inviter" clearable disabled></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.socialUniformCreditCode')" prop="socialUniformCreditCode">
                    <!--社会统一信用代码-->
                    <el-input v-model.trim="basicInfoForm.socialUniformCreditCode" clearable :disabled="!(canEdit || canUpdate)"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item :label="$t('supplierManage.auditStatus')" prop="auditStatus">
                    <!--审核状态-->
                    <ic-select clearable table="TM_SUPPLIER" field="AUDIT_STATUS" v-model="basicInfoForm.auditStatus" disabled></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if='emplFlag == "MDM"'>
                  <el-form-item :label="$t('settlementUnit.department')" prop="department">
                    <!--部门 MDM可看-->
                    <ic-select clearable table="TM_SUPPLIER" field="DEPARTMENT" v-model="basicInfoForm.department" disabled></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if='emplFlag == "MDM"'>
                  <el-form-item :label="$t('common.status')" prop="status">
                    <!--启用禁用 MDM可看-->
                    <el-select v-model="basicInfoForm.status" :placeholder="$t('common.sel')" :disabled="!(canEdit || canUpdate)">
                      <el-option :label="$t('base.common.statusAble')" value="1"></el-option>
                      <el-option :label="$t('base.common.statusDisable')" value="0"></el-option>
                      <el-option label="已淘汰" value="2"></el-option>
                    </el-select>
                    <!-- <ic-select clearable table="COMMON" field="DISABLE_ENABLE_CODE" v-model="unitOfAccountForm.status"></ic-select> -->
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if='emplFlag == "MDM"'>
                  <el-form-item :label="$t('supplierManage.SubmitBy')" prop="ssCategoryLeaderId">
                    <!--选择审批人-->
                    <el-select v-model="basicInfoForm.ssCategoryLeaderId" clearable :disabled="!(canEdit || canUpdate)">
                      <el-option :key="index" v-for="(item, index) in SubmitBySSList" :label="item.userName" :value="item.tmUserId"></el-option>
                    </el-select>
                  </el-form-item>
                  <!-- <el-form-item :label="$t('BC.SubmitBy')" prop="ssCategoryLeaderName">
                                        <el-input v-model.trim="basicInfoForm.ssCategoryLeaderName" clearable disabled></el-input>
                                    </el-form-item> -->
                </el-col>

              </el-row>
            </el-form>
            <template v-if="canEdit || canUpdate">
              <el-button type="primary" v-acl="SubmitSupplierResource" @click="addSupplierContacts()" v-if="formlinkUsers.linkUsersList.length < 5 && isGroup">{{ $t('common.addNew') }}</el-button>
              <el-button type="danger" v-acl="SubmitSupplierResource" @click="delSupplierContacts()" v-if="isGroup">{{ $t('common.del') }}</el-button>
            </template>
            <el-form :model="formlinkUsers" ref="formlinkUsers" :rules="ruleslinkUsers">
              <el-table :data="formlinkUsers.linkUsersList" ref="linkUsersList" border highlight-current-row max-height='420'>
                <el-table-column prop="trLinkUserId" type="selection" :selectable="selectable" min-width="55" />
                <el-table-column show-overflow-tooltip prop="name" :label="$t('supplierManage.supplierContacts')" min-width="120">
                  <!-- 联系人 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'linkUsersList.' + scope.$index + '.name'" :rules="ruleslinkUsers.name">
                      <el-input v-model="scope.row.name">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.supplierTel')" min-width="120">
                  <!-- 联系电话 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'linkUsersList.' + scope.$index + '.tel'" :rules="ruleslinkUsers.tel">
                      <el-input v-model="scope.row.tel" maxlength="60">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120">
                  <!-- 联系电话 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'linkUsersList.' + scope.$index + '.officeTel'" :rules="ruleslinkUsers.officeTel">
                      <el-input v-model="scope.row.officeTel" maxlength="60">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 邮箱 -->
                <el-table-column show-overflow-tooltip prop="email" label="邮箱" min-width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'linkUsersList.' + scope.$index + '.email'" :rules="ruleslinkUsers.email">
                      <el-input v-model="scope.row.email" maxlength="50">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- 职位 -->
                <el-table-column show-overflow-tooltip prop="title" :label="$t('supplierManage.position')" min-width="120">
                  <template slot-scope="scope">
                    <el-form-item :prop="'linkUsersList.' + scope.$index + '.title'" :rules="ruleslinkUsers.title">
                      <!-- <el-input v-model="scope.row.title">&nbsp;</el-input> -->
                      <ic-select table="TM_SUPPLIER" field="CONTACT_POSITION" :disabled="scope.row.title=='KA'&&scope.$index==0" v-model="scope.row.title" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card">
            <!--供应商地址信息-->
            <div slot="header" class="clearfix">
              <span>{{ $t('supplierManage.supplierAddressInfo') }}</span>
            </div>
            <template v-if="canEdit || canUpdate">
              <el-button type="primary" v-acl="SubmitSupplierResource" @click="addAddress()" v-if="formAddress.plantList && groupType != 'CARRIER' && isGroup">{{ $t('common.addNew') }}</el-button>
              <!--供应商新增-->
              <!--<el-button type="primary" @click="DCaddAddress()" v-if="groupType=='DC'">{{$t('common.addNew')}}</el-button>DC新增-->
              <el-button type="danger" v-acl="SubmitSupplierResource" @click="delAddress()" v-if="groupType != 'CARRIER' && isGroup">{{ $t('common.del')
              }}</el-button>
            </template>
            <el-form :model="formAddress" ref="formAddress" :rules="rulesAddress">
              <el-table :data="formAddress.plantList" ref="plantList" border highlight-current-row max-height='420' class="addressBox">
                <el-table-column prop="tmSupplierId" type="selection" min-width="55" :selectable="selectFunc" />
                <el-table-column show-overflow-tooltip prop="supplierName" :label="$t('sys.roleList.roleCN')" min-width="120">
                  <!-- 中文名称 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.supplierName'" :rules="rulesAddress.supplierName">
                      <el-input v-model="scope.row.supplierName" :disabled='!(canEdit || canUpdate)' maxlength="20">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="supplierNameEn" :label="$t('sys.roleList.roleEN')" min-width="120">
                  <!-- 英文名称 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.supplierNameEn'" :rules="rulesAddress.supplierNameEn">
                      <el-input v-model="scope.row.supplierNameEn" maxlength="100">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop='plantType' :label="$t('settlementUnit.addressType')" min-width="120">
                  <!-- 地址类型 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.plantType'" :rules="rulesAddress.plantType" class="noSuffix">
                      <el-select v-model="scope.row.plantType" disabled>
                        <el-option key="REG" label="注册地址" value="REG"></el-option>
                        <el-option key="PLANT" label="工厂地址" v-if="groupType == 'SUPPLIER'" value="PLANT"></el-option>
                        <el-option key="WAREHOUSE" label="仓库" v-else value="WAREHOUSE"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="tmAreaId" :label="$t('supplierManage.area')" min-width="180">
                  <template slot-scope="scope">
                    <!--区域-->
                    <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-if="scope.row.tmAreaId">{{
                      scope.row.areaName }}</el-link>
                    <el-link type="primary" @click="selectArea(scope.row, scope.$index)" v-else>{{
                      $t('supplierManage.area') }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="address" :label="$t('settlementUnit.detailAddress')" min-width="120">
                  <!-- 详细地址 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.address'" :rules="rulesAddress.address">
                      <el-input v-model="scope.row.address" maxlength="33">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')" min-width="120">
                  <!-- 联系人 -->
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.linkman">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name
                        }}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.linkman
                      }}</el-link>
                    </el-tooltip>
                    <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)" v-else>添加</el-link>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="telephoneNo" :label="$t('settlementUnit.supplierTel')" min-width="120">
                  <!-- 联系电话 -->
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.telephoneNo">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name
                        }}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.telephoneNo
                      }}</el-link>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="contactOfficeTel" label="办公室电话" min-width="120">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.contactOfficeTel">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name
                        }}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{
                        scope.row.contactOfficeTel
                      }}</el-link>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="emailAddress" :label="$t('sys.userList.email')" min-width="120">
                  <!-- 邮箱 -->
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top" v-if="scope.row.emailAddress">
                      <div slot="content">
                        <span v-for="(item, index) in scope.row.supplierContactList" :key="index">联系人：{{ item.name
                        }}，电话：{{ item.tel }}，邮箱：{{ item.email }}，办公室电话：{{ item.officeTel }}<br /></span>
                      </div>
                      <el-link type="primary" @click="addAddressUser(scope.row, scope.$index)">{{ scope.row.emailAddress
                      }}</el-link>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="postCode" :label="$t('settlementUnit.Postcode')" min-width="120">
                  <!-- 邮编 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.postCode'" :rules="rulesAddress.postCode">
                      <el-input v-model="scope.row.postCode" maxLength='6' onkeyup="this.value=this.value.replace(/\D/g,'')">&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip :label="$t('settlementUnit.qualificationFile')" min-width="80" style="position: relative;" v-if="isGroup">
                  <!-- 资质文件 -->
                  <template slot-scope="scope">
                    <i class="el-icon-folder-checked iconUploadSuccess" v-if="scope.row.existsFile == 'Y'"></i>
                    <el-link type="primary" v-acl="SubmitSupplierResource" @click="seeQualificationFile(scope.row, scope.$index)">{{ $t('common.upload')
                    }}</el-link>
                    <!--上传-->
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop='status' label="状态" min-width="120">
                  <!-- 启用禁用 -->
                  <template slot-scope="scope">
                    <el-form-item :prop="'plantList.' + scope.$index + '.status'" :rules="rulesAddress.status" v-if="scope.$index != 0">
                      <el-select v-model="scope.row.status" :disabled="emplFlag == 'SUP'">
                        <!-- <el-select v-model="scope.row.status" :disabled="emplFlag=='SUP' || scope.row.parentId"> -->
                        <el-option key="0" :label="$t('supplierManage.Unapprove')" value="0"></el-option>
                        <el-option key="1" :label="$t('supplierManage.Approve')" value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-card>
          <el-card class="box-card" v-if="tmSupplierId">
            <!--其他附件-->
            <div slot="header" class="clearfix" style="display: flex;align-items: center;">
              <span>{{ $t('common.otherAttachments') }}</span>
              <el-upload v-acl="SubmitSupplierResource" v-if="fileList.length < 10 && (canEdit || canUpdate) && isGroup" style="margin-left:20px" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
                <el-button slot="trigger" size="small" type="primary">{{ $t('common.selectFile') }}</el-button>
                <!--选取文件-->
              </el-upload>
            </div>
            <el-table :data="fileList" border highlight-current-row class="table">
              <el-table-column show-overflow-tooltip sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                <!--文件-->
                <template slot-scope="scope">
                  <el-link type="primary" @click.native="downloadFile(scope.row)">{{ scope.row.documentName }} </el-link>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip sortable prop="userName" :label="$t('common.createBy')" min-width="130px"></el-table-column>
              <!--创建人-->
              <el-table-column show-overflow-tooltip sortable prop="createDate" :label="$t('common.createDate')" min-width="130px">
                <!--创建时间-->
                <template slot-scope="scope">
                  {{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm") }}
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="tmDocumentId" :label="$t('common.operation')" min-width="130px" v-if="(canEdit || canUpdate) && isGroup">
                <template slot-scope="scope">
                  <el-link type="primary" v-acl="SubmitSupplierResource" @click.native.prevent="deleteFile(scope.row.tmDocumentId, scope.$index, fileList, scope.row)">{{
                      $t('common.del') }}</el-link>
                  <!--删除-->
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="$t('common.approvalLog')" name="2">
        <el-table :data="auditLog" border highlight-current-row class="table">
          <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime')">
            <template slot-scope="scope">{{ scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss") }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation')"></el-table-column>
          <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.opinion')">
            <template slot-scope="scope">
              <div v-html="scope.row.comments"></div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="addressAddSupplierContactListDialog" width="80%" :before-close="closeSupplierContactsAddress">
      <!--地址 添加联系人弹窗-->
      <el-button type="primary" v-acl="SubmitSupplierResource" @click="addSupplierContactsAddress()" v-if="addressAddSupplierContactListForm.addresslinkUsersList.length < 5">{{ $t('common.addNew') }}</el-button>
      <el-button type="danger" v-acl="SubmitSupplierResource" @click="delSupplierContactsAddress()">{{ $t('common.del') }}</el-button>
      <el-form :model="addressAddSupplierContactListForm" ref="addressAddSupplierContactListForm" :rules="rulesAddressAddSupplierContactList">
        <el-table :data="addressAddSupplierContactListForm.addresslinkUsersList" ref="addresslinkUsersList" border highlight-current-row max-height='420'>
          <el-table-column prop="trLinkUserId" type="selection" min-width="55" :selectable="(row) => !row.titleDisabled" />
          <el-table-column show-overflow-tooltip prop="name" :label="$t('settlementUnit.contacts')" min-width="120">
            <!-- 联系人 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.name'" :rules="rulesAddressAddSupplierContactList.name">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.name' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.name:[]"> -->
                <el-input v-model="scope.row.name">&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="tel" :label="$t('settlementUnit.tel')" min-width="120">
            <!-- 联系电话 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.tel'" :rules="rulesAddressAddSupplierContactList.tel">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.tel' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.tel:[]"> -->
                <el-input v-model="scope.row.tel" maxlength="60">&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="officeTel" label="办公室电话" min-width="120">
            <!-- 联系电话 -->
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.officeTel'" :rules="rulesAddressAddSupplierContactList.officeTel">
                <!-- <el-form-item :prop=" 'addresslinkUsersList.' + scope.$index + '.tel' " :rules="scope.$index==0?rulesAddressAddSupplierContactList.tel:[]"> -->
                <el-input v-model="scope.row.officeTel" maxlength="60">&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="email" :label="$t('sys.userList.email')" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.email'" :rules="rulesAddressAddSupplierContactList.email">
                <el-input v-model="scope.row.email" maxlength="50">&nbsp;</el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="title" :label="$t('supplierManage.position')" min-width="120">
            <template slot-scope="scope">
              <el-form-item :prop="'addresslinkUsersList.' + scope.$index + '.title'" :rules="rulesAddressAddSupplierContactList.title">
                <ic-select table="TM_UNIT_OF_ACCOUNT" field="REG_CONTACT_TYPE" v-model="scope.row.title" v-if='rowIndex == 0' :disabled='scope.row.titleDisabled'></ic-select>
                <ic-select table="TM_UNIT_OF_ACCOUNT" field="PLANT_CONTACT_TYPE" v-model="scope.row.title" v-else :disabled='scope.row.titleDisabled'></ic-select>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" v-acl="SubmitSupplierResource" @click="saveSupplierContactsAddress">{{ $t('common.save') }}</el-button>
        <el-button type="primary" @click="closeSupplierContactsAddress()">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="AreaDialog" width="400px">
      <!--区域弹框-->
      <el-form :model="AreaForm" ref="AreaForm" label-width="60px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.country')" prop="country">
              <el-select v-model="AreaForm.country" :placeholder="$t('common.sel')" @change="countryChange" :disabled="disableAreaInput">
                <el-option clearable v-for="item in countryList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.province')" prop="province">
              <el-select v-model="AreaForm.province" :placeholder="$t('common.sel')" @change="provinceChange" :disabled="disableAreaInput">
                <el-option clearable v-for="item in provinceList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('settlementUnit.city')" prop="city">
              <el-select v-model="AreaForm.city" :placeholder="$t('common.sel')" @change="cityChange" :disabled="disableAreaInput">
                <el-option clearable v-for="item in cityList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <el-form-item :label="$t('DC.tmAreaId')" prop="tmAreaId">
              <el-select v-model="AreaForm.tmAreaId" :placeholder="$t('common.sel')" @change="AreaChange" :disabled="disableAreaInput">
                <el-option clearable v-for="item in AreaList" :key="item.tmAreaId" :label="item.name" :value="item.tmAreaId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" v-acl="SubmitSupplierResource" @click="saveArea" v-if="!disableAreaInput">{{ $t('common.save') }}</el-button>
        <el-button type="primary" @click="AreaDialog = false">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="qualificationsDialog" width="50%" :before-close='closeQualificationsDialog'>
      <!--资质文件弹框-->
      <el-table :data="qualificationsList" border highlight-current-row class="table">
        <el-table-column show-overflow-tooltip prop="HeaderName" :label="$t('common.file')" max-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="documentName" :label="$t('supplierManage.fileName')">
          <!--文件-->
          <template slot-scope="scope">
            <el-link type="primary" v-if="scope.row.tmDocumentId" @click.native="downloadQualifications(scope.row)">{{
              scope.row.documentName }} </el-link>
            <span v-else>{{ scope.row.documentName }}</span>
          </template>
        </el-table-column>
        <el-table-column max-width="130px" :label="$t('common.operation')">
          <template slot-scope="scope">
            <div v-acl="SubmitSupplierResource" @click="getFileIndex(scope.$index)">
              <el-upload style="margin-left:20px" ref="upload" action="upload" :http-request="uploadQualifications" :show-file-list="false" multiple name="file">
                <el-button slot="trigger" size="small" type="primary">{{ $t('common.selectFile') }}</el-button>
              </el-upload>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="closeQualificationsDialog">{{ $t('common.close') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="$t('supplierManage.approvalWindow')" :visible.sync="approvalVisible" width="25%">
      <el-form :model="approvaForm" ref="approvaForm" :rules="approvaRules" inline label-width="90px">
        <el-form-item :label="$t('storeFeedback.auditor')" prop="auditor">
          <el-input v-model="approvaForm.auditor" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.approvalTime')" prop="approvalTime">
          <el-input v-model="approvaForm.approvalTime" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.approvalResults')" prop="approvalResults">
          <el-radio-group v-model="approvaForm.approvalResults" @change="ResultsChange">
            <el-radio label="PASS">{{ $t('common.pass') }}</el-radio>
            <el-radio label="REJECT">{{ $t('common.noPass') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('common.approvalRemarks')" prop="approvalRemarks" :rules="approvaForm.approvalResults == 'REJECT' ? approvaForm.approvalRemarks : []">
          <el-input v-model="approvaForm.approvalRemarks" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="300" style="width:200px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approvalVisible = false" type="primary">{{ $t('common.cancel') }}</el-button>
        <el-button v-acl="SubmitSupplierResource" type="primary" @click="approvalConfirm()">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="85%">
      <SelDc v-if="DestroyIncomeStatistics == true" ref="selectDcMultipleRef" :multipleSelectionFlag="true" @subCallMethod="selectDcMethod"></SelDc>
    </el-dialog>
  </div>
</template>
<script>
import BCApi from "@/api/BC/BC";
import { Message } from "element-ui";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import supplierApi from "@/api/supplier/supplier";
import commonFun from "@/utils/commonFun";
import commonConstatns from "@/constants/commonConstants";
import SelDc from "@/components/page/supplierManage/componentsDC";
import { apiService } from "@/api/material/material-master-data";
export default {
  components: { IcSelect, SelDc },
  data() {
    var checkTel = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let reg01 = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/;
      let reg02 = /^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/;
      if (reg01.test(value) || reg02.test(value)) {
        callback();
      } else {
        callback(new Error('格式不正确'));
      }
    };
    var checkEmail = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t("sys.userList.inputEmail")));
      } else {
        callback();
      }
    };
    return {
      disableAreaInput: false,
      canEdit: true,
      canUpdate: '',
      canChangeFormal: '',
      canAudit: '',
      canMdmUpdate: true,
      auditStatus: '',
      supplierstatus: '',
      addressAddSupplierContactListDialog: false,
      addressAddSupplierContactListForm: {
        addresslinkUsersList: []
      },
      rulesAddressAddSupplierContactList: {
        name: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        tel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        officeTel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        email: [
          { required: true, trigger: ["blur"], validator: checkEmail }
        ],
        title: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      lawFileList: [],
      currentTab: '1',
      auditLog: [],//审批日志
      approvaForm: {
        auditor: localStorage.getItem("ms_userCd"),
        approvalTime: this.$options.filters["dateFormatFilter"](new Date()),
        approvalResults: '',
      },
      approvaRules: {
        approvalResults: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        approvalRemarks: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
      },
      approvalVisible: false,
      categoryList1: [],
      categoryList2: [],
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      contactsList: [1],
      basicInfoForm: {
        ssCategoryLeaderId: '',
      },
      fileList: [],
      supplierCode: false,
      CategoryInfoForm: {
        categoryLevel1Id: [],
        categoryLevel2Id: [],
      },
      CategoryInfoRules: {
        categoryLevel1Id: [
          { type: 'array', required: true, message: "不能为空", trigger: 'change' }
        ],
        categoryLevel2Id: [
          { type: 'array', required: true, message: this.$t("common.canNotBeEmpty"), trigger: 'change' }
        ],
      },
      countryName: '',
      provinceName: '',
      cityName: '',
      areaName: '',
      rowIndex: '',
      countryList: [],
      provinceList: [],
      cityList: [],
      AreaList: [],
      AreaDialog: false,
      AreaForm: {
        country: '',
        province: '',
        city: '',
        tmAreaId: '',
      },
      qualificationsDialog: false,
      tmSupplierId: '',
      groupType: '',
      detailData: {},
      basicInfoRules: {
        supplierName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        supplierNameEn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        supplierNameShort: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        ssCategoryLeaderId: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] }
        ],
        socialUniformCreditCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      formlinkUsers: {
        linkUsersList: [
          {
            delIds: 0,
            name: "",
            tel: "",
            officeTel: "",
            email: "",
            title: "KA",
          }
        ],
      },
      ruleslinkUsers: {
        name: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        tel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        officeTel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        email: [
          { required: true, trigger: ["blur"], validator: checkEmail }
        ],
        title: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
      },
      formAddress: {
        plantList: [{ plantType: 'REG', status: '1', existsFile: 'N' }, { plantType: 'PLANT', status: '1', existsFile: 'N' }],
      },
      rulesAddress: {
        supplierName: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        supplierNameEn: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        address: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        linkman: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        telephoneNo: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        contactOfficeTel: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        emailAddress: [
          { required: true, validator: checkEmail, trigger: ["blur"] }
        ],
        postCode: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur"] }
        ],
        status: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["change"] }
        ],
      },
      qualificationsList: [
        {
          HeaderName: '营业执照(三合一)'
        },
        {
          HeaderName: '生产许可证'
        },
        {
          HeaderName: '经营许可证'
        }
      ],
      QualificationFileId: '',//上传资质文件用到的id
      seq: '',
      haveQualifications: false,
      showSelDcMultipleDialog: false,
      DestroyIncomeStatistics: "",
      emplFlag: "",
      supplierCategoryList: [],//供应商品类信息
      createType: '',
      SubmitBySSList: [],
      isGroup: true
    }
  },
  computed: {
    fileUploadUrl() {
      if (commonFun.isNotEmpty(this.bizId) && this.bizId > 0) {
        return commonConstatns.fileUploadUrl + `/${this.recType}${this.seq == null ? '' : '/' + this.seq}/${this.bizId}`;
      } else {
        return commonConstatns.fileUploadUrl;
      }
    },
  },
  created() {
    this.groupType = this.$route.query.groupType;
    this.createType = this.$route.query.createType;
    this.basicInfoForm.department = this.$route.query.createType;
    this.basicInfoForm.groupType = this.$route.query.groupType;
    if (this.$route.query.groupType == 'CARRIER') {//如果是承运商,DC 地址只有一行
      this.formAddress.plantList.pop()
    }
    if (this.$route.query.groupType == 'DC') {
      this.formAddress.plantList[1].plantType = 'WAREHOUSE'
    }
    let emplFlag = localStorage.getItem("ms_emplFlag");
    //供应商用户
    if (emplFlag === 'SUP') {
      this.emplFlag = 'SUP';
    } else {
      this.getCategoryList()
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'IS_MDM') {
          this.emplFlag = 'MDM';
        }
      }
    }
    if (this.$route.query.tmSupplierId) {
      this.tmSupplierId = this.$route.query.tmSupplierId;
      this.getDetail(this.$route.query.tmSupplierId)
      this.getFiles();

    }
    if (this.$route.query.id) {
      this.tmSupplierId = this.$route.query.id;
      this.getDetail(this.$route.query.id)
      this.getFiles();
    }
    this.getArea()
    // if (this.$route.query.createType) {//从任务管理里面进来 没有这个参数
    this.getSubmitBySS()
    // }
  },
  mounted() {
    let ms_roles = JSON.parse(localStorage.getItem("ms_roles"));
    console.log('ms_roles', ms_roles);
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    console.log('dataScope', dataScope);
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    const emplFlag = localStorage.getItem("ms_emplFlag");
    console.log('groupableSupplier', groupableSupplier);
    if (((!dataScope || (dataScope && dataScope == "GROUP_ADMIN")) && groupableSupplier == 'true') || groupableSupplier == 'false' || ms_roles.indexOf('MDM_TEAM') !== -1) {
      this.isGroup = true
    } else {
      this.isGroup = false
    }
    console.log('isGroup', this.isGroup);
  },
  methods: {
    selectFunc(row, index) {
      let flag = true;
      // parentId为空并且index大于1的可以勾选
      if (index > 1 && !row.parentId) {
        flag = true
      } else {
        flag = false
      }
      return flag
    },
    getDetail(tmSupplierId) {
      let that = this
      supplierApi.potentialSupplierDetail(tmSupplierId).then(res => {
        that.detailData = res.data
        that.createType = res.data.department
        // if (!this.$route.query.createType) {
        //   this.getSubmitBySS()
        // }
        that.auditStatus = res.data.auditStatus
        that.supplierstatus = res.data.supplierStatus
        that.basicInfoForm = {
          supplierName: res.data.supplierName,
          supplierNameShort: res.data.supplierNameShort,
          invitationCode: res.data.invitationCode,
          auditStatus: res.data.auditStatus,
          supplierNameEn: res.data.supplierNameEn,
          groupType: res.data.groupType,
          department: res.data.department,
          inviter: res.data.inviter,
          status: res.data.status,
          ssCategoryLeaderId: res.data.ssCategoryLeaderId,
          socialUniformCreditCode: res.data.socialUniformCreditCode,
        }
        if (that.basicInfoForm.ssCategoryLeaderId) {
          that.basicInfoForm.ssCategoryLeaderId = parseInt(that.basicInfoForm.ssCategoryLeaderId)
        }
        let linkUsersList = res.data.supplierContactList
        if (linkUsersList.length > 0) {
          for (let i = 0, len = linkUsersList.length; i < len; i++) {
            linkUsersList[i].delIds = i;
          }
          this.formlinkUsers.linkUsersList = linkUsersList
        }
        if (this.$route.query.groupType == 'SUPPLIER' || this.$route.query.groupType == 'DC') {
          let plantList = res.data.plantList
          if (plantList.length > 0) {
            for (let i = 0, len = plantList.length; i < len; i++) {
              plantList[i].delIds = i;
            }
            that.formAddress.plantList = plantList
          }
        } else {
          that.formAddress.plantList = res.data.plantList
        }
        this.supplierCategoryList = res.data.supplierCategoryList
        let supplierCategoryList = res.data.supplierCategoryList

        let categoryLevel1IdTemp = []
        supplierCategoryList.forEach((item) => {
          categoryLevel1IdTemp.push(item.categoryLevel1Id);
          that.CategoryInfoForm.categoryLevel2Id.push(item.categoryLevel2Id);
        });

        that.CategoryInfoForm.categoryLevel1Id = Array.from(new Set(categoryLevel1IdTemp))
        if (supplierCategoryList.length > 0) {
          apiService.findCategory({ categoryLevel: 2, pidList: that.CategoryInfoForm.categoryLevel1Id }).then((resCategory) => {
            console.log(resCategory)
            that.categoryList2 = resCategory.data
          });
        }
        that.lawFileList = [res.data.lawFile]
        that.canEdit = res.data.canEdit
        that.canUpdate = res.data.canUpdate
        that.canChangeFormal = res.data.canChangeFormal
        that.canMdmUpdate = res.data.canMdmUpdate
        that.canAudit = res.data.canAudit
        that.auditLog = res.data.workFlowLogList
        if (!this.$route.query.groupType) {
          that.groupType = res.data.groupType//从任务中心进来。没有携带groupType参数
          if (res.data.groupType == 'CARRIER' && that.formAddress.plantList.length == 2) {//如果是承运商 地址只有一行
            that.formAddress.plantList.pop()
          }
        }
      });
    },
    saveDetail() {
      let that = this
      let data = that.detailData
      data.supplierName = this.basicInfoForm.supplierName
      data.groupType = this.basicInfoForm.groupType
      data.ssCategoryLeaderId = this.basicInfoForm.ssCategoryLeaderId
      data.supplierNameEn = this.basicInfoForm.supplierNameEn
      data.supplierNameShort = this.basicInfoForm.supplierNameShort
      data.invitationCode = this.basicInfoForm.invitationCode
      data.auditStatus = this.basicInfoForm.auditStatus
      data.department = this.basicInfoForm.department
      data.inviter = this.basicInfoForm.inviter
      data.status = this.basicInfoForm.status
      data.socialUniformCreditCode = this.basicInfoForm.socialUniformCreditCode
      data.supplierContactList = this.formlinkUsers.linkUsersList
      data.plantList = this.formAddress.plantList
      data.createType = this.createType
      let arr = that.supplierCategoryList
      var supplierCategoryList = arr.map(function (item) {
        if (item["pid"]) {
          let obj = {
            categoryLevel1Id: item["pid"],
            categoryLevel1Name: item["pname"],
            categoryLevel2Id: item["tmCategoryId"],
            categoryLevel2Name: item["name"],
          };
          return obj;
        } else {
          return item;
        }

      });
      data.supplierCategoryList = supplierCategoryList
      console.log(data)
      supplierApi.saveResource(data).then(res => {
        console.log(res)
        if (res.code == '200') {
          that.tmSupplierId = res.data
          that.$message({
            message: this.$t("common.saveSuccess"),
            type: "success"
          });
        }
        that.$router.replace({
          path: `/supplierResourceManageList-detail`,
          query: { tmSupplierId: res.data, timestamp: new Date().getTime() }
        })
        that.getDetail(res.data)
      });
    },
    submitDetail() {
      let that = this
      const p1 = new Promise((resolve, reject) => {
        this.$refs["basicInfoForm"].validate(valid => {
          if (valid) resolve()
          return false;
        })
      })
      if (this.formlinkUsers.linkUsersList.length == 0) {
        that.$message({ message: that.$t("settlementUnit.leastContact"), type: "warning" });
        return
      }
      if (this.formAddress.plantList.length < 2 && that.groupType != 'CARRIER') {
        that.$message({ message: '至少两行地址明细', type: "warning" });
        return
      }
      const p2 = new Promise((resolve, reject) => {
        this.$refs["formlinkUsers"].validate(valid => {
          if (valid) resolve()
        })
      })
      const p3 = new Promise((resolve, reject) => {
        this.$refs["formAddress"].validate(valid => {
          if (valid) resolve()
        })
      })
      let list = this.formAddress.plantList
      for (let i = 0, len = list.length; i < len; i++) {
        if (commonFun.isEmpty(list[i].tmAreaId)) {
          that.$message({ message: that.$t("supplierManage.selectArea"), type: "warning" });
          return false;
        }
        if (commonFun.isEmpty(list[i].telephoneNo)) {
          that.$message({ message: "请填写联系人", type: "warning" });
          return false;
        }
        if (list[i].existsFile && list[i].existsFile == 'N') {
          that.$message({ message: "请上传资质文件", type: "warning" });
          return false;
        }

      }
      let p4 = ''
      if (this.$refs["CategoryInfoForm"]) {
        p4 = new Promise((resolve, reject) => {
          this.$refs["CategoryInfoForm"].validate(valid => {
            if (valid) resolve()
            return false;
          })
        })
      }
      Promise.all([p1, p2, p3, p4]).then(() => {
        let data = that.detailData
        data.supplierName = this.basicInfoForm.supplierName
        data.ssCategoryLeaderId = this.basicInfoForm.ssCategoryLeaderId
        data.groupType = this.basicInfoForm.groupType
        data.supplierNameEn = this.basicInfoForm.supplierNameEn
        data.supplierNameShort = this.basicInfoForm.supplierNameShort
        data.invitationCode = this.basicInfoForm.invitationCode
        data.auditStatus = this.basicInfoForm.auditStatus
        data.department = this.basicInfoForm.department
        data.inviter = this.basicInfoForm.inviter
        data.status = this.basicInfoForm.status
        data.socialUniformCreditCode = this.basicInfoForm.socialUniformCreditCode
        data.supplierContactList = this.formlinkUsers.linkUsersList
        data.plantList = this.formAddress.plantList
        data.createType = this.createType
        let arr = that.supplierCategoryList
        var supplierCategoryList = arr.map(function (item) {
          if (item["pid"]) {
            let obj = {
              categoryLevel1Id: item["pid"],
              categoryLevel1Name: item["pname"],
              categoryLevel2Id: item["tmCategoryId"],
              categoryLevel2Name: item["name"],
            };
            return obj;
          } else {
            return item;
          }

        });
        data.supplierCategoryList = supplierCategoryList
        console.log(data)
        supplierApi.submitResource(data).then(res => {
          console.log(res)
          if (res.code == '200') {
            that.$message({
              message: this.$t("common.submitSuccess"),
              type: "success"
            });
            that.historyBack();
          }
        });
      })
    },
    //保存区域
    saveArea() {
      let that = this
      this.formAddress.plantList[that.rowIndex].country = that.AreaForm.country
      this.formAddress.plantList[that.rowIndex].province = that.AreaForm.province
      this.formAddress.plantList[that.rowIndex].city = that.AreaForm.city
      this.formAddress.plantList[that.rowIndex].tmAreaId = that.AreaForm.tmAreaId
      that.$set(that.formAddress.plantList[that.rowIndex], `areaName`, this.countryName + this.provinceName + this.cityName + this.areaName)
      console.log(this.countryName + this.provinceName + this.cityName + this.areaName)
      this.AreaDialog = false
      console.log(this.formAddress.plantList)
    },
    selectArea(row, index) {
      let that = this
      // if(that.groupType=='CARRIER'){
      // // if(index!=0 && that.groupType!='CARRIER'){//不是 第一行并且是承运商则不可编辑
      //     this.disableAreaInput = true
      // }else{
      //     this.disableAreaInput = false
      // }
      //取出省市区 带到弹框中
      this.AreaDialog = true
      this.rowIndex = index
      console.log(row)
      if (commonFun.isNotEmpty(row.country)) {
        that.countryChange(row.country)
          .then(() => that.provinceChange(row.province))
          .then(() => that.cityChange(row.city))
          .then(() => {
            that.AreaForm.country = parseInt(row.country)
            that.AreaForm.province = parseInt(row.province)
            that.AreaForm.city = parseInt(row.city)
            that.AreaForm.tmAreaId = row.tmAreaId
          });
      }
      /*
      Promise.all([that.countryChange(), that.provinceChange(),that.cityChange()]).then(()=>{
          if(commonFun.isNotEmpty(row.country)){
              that.AreaForm.country = parseInt(row.country)
              that.AreaForm.province = parseInt(row.province)
              that.AreaForm.city =  parseInt(row.city)
              that.AreaForm.tmAreaId =  row.tmAreaId
          }
      })
      */

    },
    initializaRowAddress(row) {
      // let that = this
      // let str = ''
      // console.log(row)
      // let country = row.country
      // let province = row.province
      // let city = row.city
      // let area = row.tmAreaId
      // that.countryChange(row.country)
      // that.provinceChange(row.province)
      // that.cityChange(row.city)
      // Promise.all([that.countryChange(), that.provinceChange(),that.cityChange()]).then(()=>{
      //     // this.provinceList
      //     forEach
      //     for(var i=1;i<=10;i++) {
      //         if(i==8) {
      //             break;
      //         }
      //     }
      //     console.log(this.provinceList)
      // })
    },
    //获取国家
    getArea() {
      let that = this
      let data = {
        areaLevel: '0',
      }
      supplierApi.getArea(data).then(res => {
        this.countryList = res.data
      });
    },
    //国家选择之后 获取省份
    countryChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.countryList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.countryName = selectedWorkName.name
        }
        that.AreaForm.province = ''
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '1',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.provinceList = res.data
          resolve()
        });
      })
    },
    //省份选择之后 获取市
    provinceChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.provinceList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.provinceName = selectedWorkName.name
        }
        that.AreaForm.city = ''
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '2',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.cityList = res.data
          resolve()
        });
      })

    },
    //城市选择之后 获取区域
    cityChange(val) {
      return new Promise((resolve, reject) => {
        let that = this
        let selectedWorkName = {};
        selectedWorkName = this.cityList.find((item) => {
          return item.tmAreaId === val;
          //筛选出匹配数据，是对应数据的整个对象
        });
        if (selectedWorkName) {
          that.cityName = selectedWorkName.name
        }
        that.AreaForm.tmAreaId = ''
        let data = {
          areaLevel: '3',
          parentId: val
        }
        supplierApi.getArea(data).then(res => {
          this.AreaList = res.data
          resolve()
        });
      })

    },
    //国家省市区全部选完
    AreaChange(val) {
      let that = this
      let selectedWorkName = {};
      selectedWorkName = this.AreaList.find((item) => {
        return item.tmAreaId === val;
        //筛选出匹配数据，是对应数据的整个对象
      });
      if (selectedWorkName) {
        that.areaName = selectedWorkName.name
      }
      console.log(val)
    },
    //查看资质文件
    seeQualificationFile(row, index) {
      let that = this
      this.rowIndex = index
      this.QualificationFileId = row.tmSupplierId
      this.qualificationsDialog = true
      let groupType = this.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
      if (row.tmSupplierId) {//如果有id，获取一下 三种资质文件
        this.getBusinessLicense()
        this.getProductionLicense()
        this.getManagementLicense()
      } else {
        if (that.formAddress.plantList[index].businessCertificateDocument) {
          let obj = Object.assign({}, that.qualificationsList[0], that.formAddress.plantList[index].businessCertificateDocument)
          that.qualificationsList.splice(0, 1, obj);
        }
        if (that.formAddress.plantList[index].productionLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[1], that.formAddress.plantList[index].productionLicenseDocument)
          that.qualificationsList.splice(1, 1, obj);
        }
        if (that.formAddress.plantList[index].businessLicenseDocument) {
          let obj = Object.assign({}, that.qualificationsList[2], that.formAddress.plantList[index].businessLicenseDocument)
          that.qualificationsList.splice(2, 1, obj);
        }
      }
    },
    //获取资质文件 营业执照
    getBusinessLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_CERTIFICA';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          // 通过splice()方法，删除某个元素后，再添加一个元素，达到“赋值”的效果 否则页面不会从新渲染
          let obj = Object.assign({}, that.qualificationsList[0], fileRes[0])
          that.qualificationsList.splice(0, 1, obj);
          // that.qualificationsList[0] = Object.assign({}, that.qualificationsList[0], fileRes[0])
          // that.qualificationsList[0] = Object.assign(that.qualificationsList[0],fileRes[0])
          // console.log(fileRes)
        }
      })
    },
    //获取资质文件 生产许可证
    getProductionLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'PRODUCTION_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[1], fileRes[0])
          that.qualificationsList.splice(1, 1, obj);
        }

      })
    },
    //获取资质文件 经营许可证
    getManagementLicense: function () {
      let that = this
      let attachment = {};
      attachment.seq = 'BUSINESS_LICENSE';
      attachment.tsRecId = this.QualificationFileId;
      attachment.tsReckindId = 'SUPPLIER';
      fileService.getFileList(attachment).then((fileRes) => {
        if (fileRes.length > 0) {
          let obj = Object.assign({}, that.qualificationsList[2], fileRes[0])
          that.qualificationsList.splice(2, 1, obj);
        }

      })
    },
    getFileIndex(index) {
      let that = this
      switch (index) {
        case 0:
          that.seq = 'BUSINESS_CERTIFICA'
          break;
        case 1:
          that.seq = 'PRODUCTION_LICENSE'
          break;
        case 2:
          that.seq = 'BUSINESS_LICENSE'
          break;
      }
    },
    //上传资质文件
    uploadQualifications(item) {
      let that = this;
      let QualificationFileId = this.QualificationFileId
      let seq = that.seq
      if (QualificationFileId) {//先判断有没有id
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          //调用后台方法进行文件关系维护
          let attachment = {};
          attachment.documents = res.data;
          attachment.seq = seq;
          attachment.tsRecId = QualificationFileId;
          attachment.tsReckindId = 'SUPPLIER';
          fileService.saveFile(attachment).then((saveRes) => {
            fileService.getFileList(attachment).then(fileRes => {
              //上传成功后 删除上次上传的
              if (fileRes.length > 1) {
                let tmDocumentId = fileRes[0].tmDocumentId
                fileService.deleteFile(tmDocumentId).then(Delres => {
                  switch (seq) {
                    case 'BUSINESS_CERTIFICA':
                      that.getBusinessLicense()
                      break;
                    case 'PRODUCTION_LICENSE':
                      that.getProductionLicense()
                      break;
                    case 'BUSINESS_LICENSE':
                      that.getManagementLicense()
                      break;
                  }
                });
              } else {
                switch (seq) {
                  case 'BUSINESS_CERTIFICA':
                    that.getBusinessLicense()
                    break;
                  case 'PRODUCTION_LICENSE':
                    that.getProductionLicense()
                    break;
                  case 'BUSINESS_LICENSE':
                    that.getManagementLicense()
                    break;
                }
              }

            });
            that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
          })
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      } else {
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {//没有id无法保存关系
          let documents = res.data[0]
          let obj = {}
          switch (seq) {
            case 'BUSINESS_CERTIFICA':
              obj = Object.assign({}, that.qualificationsList[0], documents)
              that.qualificationsList.splice(0, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessCertificateDocument = documents
              break;
            case 'PRODUCTION_LICENSE':
              obj = Object.assign({}, that.qualificationsList[1], documents)
              that.qualificationsList.splice(1, 1, obj);
              that.formAddress.plantList[that.rowIndex].productionLicenseDocument = documents
              break;
            case 'BUSINESS_LICENSE':
              obj = Object.assign({}, that.qualificationsList[2], documents)
              that.qualificationsList.splice(2, 1, obj);
              that.formAddress.plantList[that.rowIndex].businessLicenseDocument = documents
              break;
          }
          that.$set(that.formAddress.plantList[that.rowIndex], `existsFile`, 'Y')
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      }
    },
    //下载资质文件
    downloadQualifications(row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //关闭地址中的上传资质文件
    closeQualificationsDialog() {
      let that = this
      this.qualificationsDialog = false
      let groupType = this.groupType
      if (groupType == 'SUPPLIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '生产许可证' },
          { HeaderName: '经营许可证' }
        ]
      } else if (groupType == 'DC') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '房产证或相关房屋合法证明' },
          { HeaderName: '道路运输经营许可证' },
        ]
      } else if (groupType == 'CARRIER') {
        that.qualificationsList = [
          { HeaderName: '营业执照(三合一)' },
          { HeaderName: '道路运输经营许可证' },
        ]
      }
    },
    //承运商和DC 添加供应商地址
    DCaddAddress() {
      this.showSelDcMultipleDialog = true;
      this.$nextTick(() => {
        this.DestroyIncomeStatistics = true;
      });
    },
    //DC选择 (地址)
    selectDcMethod: function (dcList) {
      console.log(dcList)
      let _this = this;
      this.DestroyIncomeStatistics = false;
      if (dcList.length == 0) {
        this.showSelDcMultipleDialog = false;
        return;
      }
      let platList = this.formAddress.plantList
      platList.forEach(function (item, index) {
        dcList.forEach(function (itemI, indexI) {
          // 如果选中数据跟 已经选的相等，删除对应的源数据
          if (item.tmSupplierId === itemI.tmSupplierId) {
            dcList.splice(indexI, 1);
          }
        });
      });
      if (dcList.length > 0) {
        let _arr = []
        dcList.map((item, index) => {
          _arr.push(Object.assign({}, item, { plantType: 'WAREHOUSE', status: '1' }))
        })
        _this.formAddress.plantList.push.apply(_this.formAddress.plantList, _arr)
      }
      // let temp = dcList.map(function(item,index) {
      //     let obj = {
      //         tmSupplierId: item["tmSupplierId"],
      //         supplierName: item["supplierName"],
      //         plantType:'PLANT',
      //         status:"1",
      //     }
      //     return obj;
      // });
      // if(temp.length>0){
      //     _this.formAddress.plantList.push.apply(_this.formAddress.plantList, temp)
      // }
      _this.formAddress.plantList.forEach(function (item, index) {
        if (index == 0) {
          item.plantType = 'REG'
        }
      });
      this.showSelDcMultipleDialog = false;

    },
    //添加供应商地址
    addAddress() {
      let len = this.formAddress.plantList.length;
      if (len < 1) {
        var list = {
          delIds: len,
          plantType: 'REG',
          existsFile: "N"
        };
      } else {
        if (this.groupType == 'DC') {
          var list = {
            delIds: len,
            plantType: 'WAREHOUSE',
            status: '1',
            existsFile: "N"
          };
        } else {
          var list = {
            delIds: len,
            plantType: 'PLANT',
            status: '1',
            existsFile: "N"
          };
        }
      }
      if (this.formAddress.plantList == null) {
        this.formAddress.plantList = [];
        this.formAddress.plantList.push(list);
      } else {
        this.formAddress.plantList.push(list);
      }
      console.log(this.formAddress.plantList)
    },
    //删除地址
    delAddress() {
      let that = this
      let list = this.formAddress.plantList;
      let rows = this.$refs.plantList.selection;
      console.log(rows)
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        if (that.groupType == 'SUPPLIER' || that.groupType == 'DC') {
          rows.forEach(function (item, index) {
            list.forEach(function (itemI, indexI) {
              // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
              if (item.delIds === itemI.delIds) {
                list.splice(indexI, 1);
              }
            });
          });
        } else {
          rows.forEach(function (item, index) {
            list.forEach(function (itemI, indexI) {
              // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
              if (item.tmSupplierId === itemI.tmSupplierId) {
                list.splice(indexI, 1);
              }
            });
          });

        }
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      that.formAddress.plantList = list;
    },
    selectable(row, index) {
      if (index == 0) {
        return false;
      } else {
        return true;
      }
    },
    //添加供应商联系人
    addSupplierContacts() {
      let len = this.formlinkUsers.linkUsersList.length;
      var list = {
        delIds: len,
        name: "",
        tel: "",
        officeTel: "",
        email: "",
        title: "KA",
      };
      if (this.formlinkUsers.linkUsersList == null) {
        this.formlinkUsers.linkUsersList = [];
        this.formlinkUsers.linkUsersList.push(list);
      } else {
        this.formlinkUsers.linkUsersList.push(list);
      }
      console.log("GY🚀 ~ file: supplierResourceManageDetail.vue:1610 ~ addSupplierContacts ~ this.formlinkUsers.linkUsersList:", this.formlinkUsers.linkUsersList);
    },
    delSupplierContacts() {
      let that = this
      let list = this.formlinkUsers.linkUsersList;
      console.log("GY🚀 ~ file: supplierResourceManageDetail.vue:1633 ~ delSupplierContacts ~ list:", list);
      let rows = this.$refs.linkUsersList.selection;
      console.log("GY🚀 ~ file: supplierResourceManageDetail.vue:1634 ~ delSupplierContacts ~ rows:", rows);
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      // //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.formlinkUsers.linkUsersList = list;
    },
    addAddressUser(row, index) {
      let that = this
      this.rowIndex = index
      if (row.supplierContactList && row.supplierContactList.length > 0) {
        for (let i = 0, len = row.supplierContactList.length; i < len; i++) {
          row.supplierContactList[i].delIds = i;
        }
        this.addressAddSupplierContactListForm.addresslinkUsersList = JSON.parse(JSON.stringify(row.supplierContactList))
        if (that.groupType == 'SUPPLIER') {
          if (index == 0) {//第一行是注册地址
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[1], `titleDisabled`, true)
          } else {
            console.log("点击新增的数据=====", that.addressAddSupplierContactListForm)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[1], `titleDisabled`, true)
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[2], `titleDisabled`, true)
          }
        } else {
          if (index == 0) {//第一行是注册地址
            that.$set(that.addressAddSupplierContactListForm.addresslinkUsersList[0], `titleDisabled`, true)
          }
        }
      } else {
        //先判断groupType
        if (that.groupType == 'SUPPLIER') {
          if (index == 0) {//第一行是注册地址
            that.addressAddSupplierContactListForm.addresslinkUsersList = [
              { title: '2', titleDisabled: true },
              { title: '6', titleDisabled: true },
            ]
          } else {
            that.addressAddSupplierContactListForm.addresslinkUsersList = [
              { title: '2', titleDisabled: true },
              { title: '10', titleDisabled: true },
              { title: '3', titleDisabled: true },
            ]
          }
        } else {//DC和CARRIER
          if (index == 0) {//第一行是注册地址
            that.addressAddSupplierContactListForm.addresslinkUsersList = [
              { title: '3', titleDisabled: true },
            ]
          } else {
            that.addressAddSupplierContactListForm.addresslinkUsersList = []
          }
        }

      }
      this.addressAddSupplierContactListDialog = true
    },
    //添加地址中的联系人
    addSupplierContactsAddress() {
      let len = this.addressAddSupplierContactListForm.addresslinkUsersList.length;
      var list = {
        delIds: len
      };
      if (this.addressAddSupplierContactListForm.addresslinkUsersList == null) {
        this.addressAddSupplierContactListForm.addresslinkUsersList = [];
        this.addressAddSupplierContactListForm.addresslinkUsersList.push(list);
      } else {
        this.addressAddSupplierContactListForm.addresslinkUsersList.push(list);
      }
    },
    //删除地址中的联系人
    delSupplierContactsAddress() {
      let that = this
      let list = this.addressAddSupplierContactListForm.addresslinkUsersList;
      let rows = this.$refs.addresslinkUsersList.selection;
      console.log(rows)
      if (rows.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return
      } else {
        rows.forEach(function (item, index) {
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.addressAddSupplierContactListForm.addresslinkUsersList = list;
    },
    //保存地址中的联系人
    saveSupplierContactsAddress() {
      let that = this
      let list = that.addressAddSupplierContactListForm.addresslinkUsersList
      if (list.length == 0) {
        that.$message({ message: '至少添加一行数据', type: "warning" });
        return
      }
      this.$refs.addressAddSupplierContactListForm.validate(valid => {
        if (valid) {
          that.formAddress.plantList[that.rowIndex].supplierContactList = list
          that.$set(that.formAddress.plantList[that.rowIndex], `linkman`, list[0].name)
          that.$set(that.formAddress.plantList[that.rowIndex], `telephoneNo`, list[0].tel)
          that.$set(that.formAddress.plantList[that.rowIndex], `emailAddress`, list[0].email)
          that.$set(that.formAddress.plantList[that.rowIndex], `contactOfficeTel`, list[0].officeTel)
          this.addressAddSupplierContactListDialog = false
          this.addressAddSupplierContactListForm.addresslinkUsersList = []
        } else {
          return false;
        }
      });
    },
    //关闭
    closeSupplierContactsAddress() {
      let that = this
      this.addressAddSupplierContactListDialog = false
      that.$refs.addressAddSupplierContactListForm.clearValidate();
    },
    //SS数据更新
    SSDataUpdate() {
      let that = this
      if (that.emplFlag != 'SUP' && that.groupType == 'SUPPLIER') {
        this.$refs.CategoryInfoForm.validate(valid => {
          if (!valid) {
            return false;
          } else {
            this.$confirm(this.$t('supplierManage.isUpdateData'), this.$t('common.tips'), {
              confirmButtonText: this.$t('common.confirm'),
              cancelButtonText: this.$t('common.cancel'),
              cancelButtonClass: 'el-button--primary',
              confirmButtonClass: 'el-button--primary',
              type: 'warning'
            }).then(() => {
              //调提交接口
              that.submitDetail();

            }).catch(() => { });
          }
        });
      } else {
        this.$confirm(this.$t('supplierManage.isUpdateData'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          //调提交接口
          that.submitDetail();

        }).catch(() => { });
      }

    },
    //批准供应商(转正式)
    changeFormal() {
      this.$confirm(this.$t('supplierManage.changeOfficialSupplier'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        cancelButtonClass: 'el-button--primary',
        confirmButtonClass: 'el-button--primary',
        type: 'warning'
      }).then(() => {
        supplierApi.changeFormal(this.tmSupplierId).then((res) => {
          if (res.code == 200) {
            this.historyBack()
          }
        });
      }).catch(() => {

      });
    },
    //审批
    approvalSuppliers() {
      if (this.emplFlag != 'SUP' && this.groupType == 'SUPPLIER') {
        this.$refs.CategoryInfoForm.validate(valid => {
          if (!valid) {
            return false;
          } else {
            this.approvalVisible = true
          }
        });
      } else {
        this.approvalVisible = true
      }

    },
    //审批
    approvalConfirm() {
      let that = this;
      this.$refs.approvaForm.validate(valid => {
        if (valid) {
          let arr = that.supplierCategoryList
          var supplierCategoryList = arr.map(function (item) {
            if (item["pid"]) {
              let obj = {
                categoryLevel1Id: item["pid"],
                categoryLevel1Name: item["pname"],
                categoryLevel2Id: item["tmCategoryId"],
                categoryLevel2Name: item["name"],
              };
              return obj;
            } else {
              return item;
            }

          });
          let data = {
            supplierCategoryList: supplierCategoryList,
            supplierName: that.basicInfoForm.supplierName,
            supplierNameEn: that.basicInfoForm.supplierNameEn,
            socialUniformCreditCode: that.basicInfoForm.socialUniformCreditCode,
            auditStatus: that.approvaForm.approvalResults,
            comments: that.approvaForm.approvalRemarks,
            tmSupplierId: that.tmSupplierId
          }
          console.log(data);
          supplierApi.approvalResource(data).then(res => {
            if (res.code == '200') {
              this.historyBack()
            }
          });

        } else {
          return false;
        }
      });
      this.approvalVisible = true
    },
    //文件列表数据获取
    getFiles: function () {
      let attachment = {};
      attachment.seq = '1';
      attachment.tsRecId = this.tmSupplierId;
      attachment.tsReckindId = 'GROUP_OTHER';
      fileService.getFileList(attachment).then((fileRes) => {
        this.fileList = fileRes;
      })
    },
    //文件上传
    uploadConfirm: function (item) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", item.file);
      fileService.fileUpload(formData).then((res) => {
        console.log(res.data[0].documentName)
        //调用成功后调用后台方法进行文件关系维护
        let attachment = {};
        attachment.documents = res.data;
        attachment.seq = '1';
        attachment.tsRecId = _this.tmSupplierId;
        attachment.tsReckindId = 'GROUP_OTHER';
        fileService.saveFile(attachment).then((saveRes) => {
          let data = {
            documentLog: '上传' + res.data[0].documentName,
            tmSupplierId: _this.tmSupplierId
          }
          supplierApi.UpdateDocument(data).then(res => { });
          _this.getFiles();
        })
      }).catch((error) => {
        //文件上传失败
        Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
      });
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    //文件删除
    deleteFile: function (tmDocumentId, index, files, row) {
      let that = this
      fileService.deleteFile(tmDocumentId).then((res) => {
        //删除成功删除列表数据
        that.$message({
          message: this.$t("common.success"),
          type: "success"
        });
        files.splice(index, 1);
        let data = {
          documentLog: '删除' + row.documentName,
          tmSupplierId: that.tmSupplierId
        }
        supplierApi.UpdateDocument(data).then(res => { });
      })
    },
    getCategoryList() {
      apiService.findCategory({ categoryLevel: 1 }).then((res) => {
        this.categoryList1 = res.data;
      });
    },
    //根据选中Category1查询Category2
    changeCategory1(event, val, name) {
      let that = this
      console.log(name)
      apiService.findCategory({ categoryLevel: 2, pid: val }).then((res) => {
        let arrTemp = res.data
        if (event) {
          that.categoryList2.push.apply(that.categoryList2, arrTemp)
          console.log(that.categoryList2)
        } else {
          let categoryList2 = that.categoryList2
          arrTemp.forEach(function (item, index) {
            categoryList2.forEach(function (itemI, indexI) {
              // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
              if (item.tmCategoryId === itemI.tmCategoryId) {
                categoryList2.splice(indexI, 1);
                // that.CategoryInfoForm.categoryLevel2Id
              }
            });
            that.CategoryInfoForm.categoryLevel2Id.forEach(function (itemI, indexI) {
              if (item.tmCategoryId === itemI) {
                that.CategoryInfoForm.categoryLevel2Id.splice(indexI, 1);
                that.supplierCategoryList.splice(indexI, 1);
              }
            });
          });
        }
      });
    },
    changeCategory2(event, val) {
      let supplierCategoryList = this.supplierCategoryList
      if (event) {
        this.supplierCategoryList.push(val)
      } else {
        supplierCategoryList.forEach((item, index) => {
          if ((item.tmCategoryId || item.categoryLevel2Id) == val.tmCategoryId) {
            this.supplierCategoryList.splice(index, 1);
          }
        });
      }
      console.log(this.supplierCategoryList)
    },
    apply(row) {
      let that = this
      console.log(row.status)
      if (row.status) {
        this.$confirm('再次申请将覆盖已创建的申请编号，请确认是否重新申请？', this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          customClass: 'colorBtn',
          type: 'warning'
        })
          .then(() => {
            this.$router.push({
              path: `/LegalFileDetail`,
              query: { tmSupplierId: this.detailData.tmSupplierId, supplierName: this.detailData.supplierName, formType: 0 }
            });
          });
      } else {
        this.$router.push({
          path: `/LegalFileDetail`,
          query: { tmSupplierId: this.detailData.tmSupplierId, supplierName: this.detailData.supplierName, formType: 0 }
        });
      }

    },
    //模版下载
    downloadTemplate: function (path, name) {
      fileService.downloadTemplate(path, name)
    },
    getSubmitBySS() {
      let data = {
        // type: this.createType,
        typeList: ['SS', 'ADMIN', "NFC"]
      }
      BCApi.getCategoryLeader(data).then(res => {
        if (res.code == '200') {
          // this.SubmitBySSList = res.data
          // 去重
          var hash = {}
          this.SubmitBySSList = res.data.reduce(function (item, next) {
            hash[next.userName] ? '' : hash[next.userName] = true && item.push(next)
            return item
          }, [])
        }
      });
    },
    //跳到法务文件详情
    seeLegalFileDetail(row) {
      this.$router.push({
        path: `/LegalFileDetail`,
        query: { id: row.tmLawFileId }
      });
    },
    historyBack: function () {
      this.$router.go(-1);
    },
  }

}
</script>
<style lang="scss" scoped>
.searchBox_top {
  margin-bottom: 20px;
}

.el-table {
  margin-top: 10px;
}

.el-select {
  width: 100%;
}

.scrollYBox {
  overflow-y: scroll;
  max-height: 800px;
}
</style>
<style lang="scss">
.addressBox .noSuffix .el-input__suffix {
  display: none;
}

.supplierResourceManageDetail {
  .Categorypname {
    color: #409eff;
  }

  .iconUploadSuccess {
    font-size: 24px;
    color: #f8ab01;
    position: absolute;
    top: 20px;
    right: 6px;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>
